import tokensData from "./tokens.json";

export interface TokenInfo {
  symbol: string;
  name: string;
  address: string;
  decimals: number;
  displayDecimals: number;
  priceDecimals?: number;
  sizeDecimals?: number;
  isStablecoin: boolean;
  logo: string;
}

type TokensRegistry = Record<string, Record<string, TokenInfo>>;

const tokens: TokensRegistry = tokensData;

export function getToken(chainId: string | number, symbol: string): TokenInfo | undefined {
  return tokens[String(chainId)]?.[symbol];
}

export function getTokenByAddress(chainId: string | number, address: string): TokenInfo | undefined {
  const chain = tokens[String(chainId)];
  if (!chain) return undefined;
  const normalized = address.toLowerCase();
  return Object.values(chain).find((t) => t.address.toLowerCase() === normalized);
}

export function getTokenDecimals(chainId: string | number, symbol: string): number {
  return getToken(chainId, symbol)?.decimals ?? 18;
}

export function getDisplayDecimals(chainId: string | number, symbol: string): number {
  return getToken(chainId, symbol)?.displayDecimals ?? 6;
}

/**
 * Get the number of decimal places for price display.
 * Returns undefined if not configured (caller should fall back to API-derived precision).
 */
export function getPriceDecimals(chainId: string | number, symbol: string): number | undefined {
  return getToken(chainId, symbol)?.priceDecimals;
}

export function getSizeDecimals(chainId: string | number, symbol: string): number | undefined {
  return getToken(chainId, symbol)?.sizeDecimals;
}

export function getTokenAddress(chainId: string | number, symbol: string): string | undefined {
  return getToken(chainId, symbol)?.address;
}

export function getAllTokens(chainId: string | number): TokenInfo[] {
  const chain = tokens[String(chainId)];
  return chain ? Object.values(chain) : [];
}

export function getStablecoins(chainId: string | number): TokenInfo[] {
  return getAllTokens(chainId).filter((t) => t.isStablecoin);
}
